var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"alt":"קניות ברשת וזהו :)","src":require("@/assets/logo.png")}})])],1),_c('div',[_c('SitesList'),_c('CategoryList')],1),_c('router-view'),_c('AliexpressItemFooter',{attrs:{"numberOfItems":10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }